import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

// Vertical lifecycle timeline built from existing tokens. Each item:
//   { title, subtitle?, meta?, done?, current?, content? }
// `done` → filled info dot; `current` → bold title; otherwise muted/light.
const LifecycleTimeline = ({ items = [] }) => (
  <MDBox>
    {items.map((item, idx) => {
      const isLast = idx === items.length - 1
      const reached = item.done || item.current
      return (
        <MDBox key={idx} display="flex" alignItems="stretch">
          {/* Rail: dot + connector */}
          <MDBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            mr={2}
          >
            <MDBox
              width="1rem"
              height="1rem"
              borderRadius="50%"
              bgColor={reached ? "info" : "light"}
              mt={0.5}
            />
            {!isLast && (
              <MDBox
                flexGrow={1}
                width="2px"
                bgColor="light"
                minHeight="1.5rem"
              />
            )}
          </MDBox>

          {/* Body */}
          <MDBox pb={isLast ? 0 : 2} flexGrow={1}>
            <MDTypography
              variant="button"
              fontWeight={item.current ? "bold" : "medium"}
              color={reached ? "dark" : "text"}
            >
              {item.title}
            </MDTypography>
            {item.subtitle && (
              <MDTypography variant="caption" color="text" display="block">
                {item.subtitle}
              </MDTypography>
            )}
            {item.meta && (
              <MDTypography variant="caption" color="text" display="block">
                {item.meta}
              </MDTypography>
            )}
            {item.content && <MDBox mt={1}>{item.content}</MDBox>}
          </MDBox>
        </MDBox>
      )
    })}
  </MDBox>
)

export default LifecycleTimeline
